import React, { useEffect } from "react";
import { Dropdown } from "../../../../../common/components/dropdown/Dropdown";
import * as _ from "lodash";
import { DropdownProps, useDayPicker } from "@daypicker/react";

export function DayPickerDropdown({
	options,
	value,
	onChange,
	"aria-label": ariaLabel,
}: DropdownProps) {
	const { selected } = useDayPicker();

	const handleDropdownValueChange = (key: string | number) => {
		// Mocked event structure to satisfy the compiler
		const mockEvent = {
			target: {
				value: key,
			},
		} as React.ChangeEvent<HTMLSelectElement>;

		onChange && onChange(mockEvent);
	};

	useEffect(() => {
		const isMonthsDropdown = ariaLabel === "Choose the Month";
		const newValue = isMonthsDropdown
			? // @ts-expect-error
				selected?.getMonth()
			: // @ts-expect-error
				selected?.getFullYear();

		if (value !== newValue) {
			handleDropdownValueChange(newValue);
		}
	}, [selected]);

	const dropdownItems = options?.map(({ label, value }) => ({
		key: value,
		value: label,
	}));

	const dropdownToggle =
		dropdownItems?.find((item) => item.key === value)?.value || "";

	return (
		<Dropdown
			activeItem={value?.toString()}
			additionalClasses={{ dropdown: "dropdown--light" }}
			disableMobile
			dropdownItems={dropdownItems}
			dropdownKey={_.camelCase(ariaLabel)}
			dropdownToggle={dropdownToggle}
			isDataCriterion={false}
			label={ariaLabel}
			onDropdownItemClick={handleDropdownValueChange}
			preselected
			scrollToView
		/>
	);
}
